<template>
  <div>
    <label for="combobox"
           class="block text-sm font-medium"
    >{{ localize.input_label_select_country[lang] }}</label>
    <div class="relative mt-0">
      <input id="combobox"
             type="text"
             class="w-full input-md"
             role="combobox"
             aria-controls="options"
             aria-expanded="false"
             v-model="search"
             @keydown.down="onArrowDown"
             @keydown.up="onArrowUp"
             @keydown.enter="onEnter"
             @input="showList = true"
      >
      <i class="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none"
         @click="showAll"
      >
        <svg class="h-5 w-5 text-slate-400"
             viewBox="0 0 20 20"
             fill="currentColor"
             aria-hidden="true"
        >
          <path fill-rule="evenodd"
                d="M10 3a.75.75 0 01.55.24l3.25 3.5a.75.75 0 11-1.1 1.02L10 4.852 7.3 7.76a.75.75 0 01-1.1-1.02l3.25-3.5A.75.75 0 0110 3zm-3.76 9.2a.75.75 0 011.06.04l2.7 2.908 2.7-2.908a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 01.04-1.06z"
                clip-rule="evenodd"
          />
        </svg>
      </i>

      <ul class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
          id="options"
          role="listbox"
          v-if="searchResults.length>0 && showList"

      >
        <li class="relative cursor-default select-none py-2 pl-3 pr-9 text-slate-900"
            id="option-0"
            role="option"
            tabindex="-1"
            :class="{ 'is-active': i === arrowCounter }"
            v-for="(result,i) in searchResults"
            :key="result.id"
            :value="result.alpha3"
            v-text="result.name[lang]"
            @click="setSelected(result)"

        ></li>

        <!-- More items... -->
      </ul>
    </div>
  </div>

</template>

<script setup>
import {computed, ref} from 'vue'
import countries from "../../lang/countries.json"
import localize from "../../lang/localize.json"

const props = defineProps({
  lang: {
    type: String,
    default: 'de'
  }
})



const emits = defineEmits(['setcountry'])

const showAll = () => {
  showList.value = true


}

const showList = ref(false)

const search = ref((props.lang === 'de')  ? 'Deutschland' :'')

const arrowCounter = ref(0)

const searchResults = computed(() => {

  if (search.value === '') return []

  return countries.filter(item => {
    if (item.name[props.lang].toLowerCase().includes(search.value.toLowerCase())) return item.name[props.lang]
  })

})

const setSelected = (item) => {
  search.value = item.name[props.lang]
  showList.value = false
  emits('setcountry', search.value)
}


const onArrowDown = () => {
  if (arrowCounter.value < searchResults.value.length) {
    arrowCounter.value = arrowCounter.value + 1;
  }
}

const onArrowUp = () => {
  if (arrowCounter.value > 0) {
    arrowCounter.value = arrowCounter.value - 1;
  }
}

const onEnter = () => {

  if (searchResults.value.length) {
    search.value = searchResults.value[arrowCounter.value].name[props.lang];
    arrowCounter.value = -1;
    emits('setcountry', search.value)
    showList.value = false
  }

}


</script>

<style>
.is-active {
  color: red;
}
</style>